export function getFilenameDatePrefix() {
  const date = new Date();

  const day = date.getDate().toString().padStart(2, '0'); // Add leading zero if single digit
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
  const year = date.getFullYear();

  return year + month + day;
}